import { useTranslation } from "react-i18next";

export default function SocialProof() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="font-heading text-xl md:text-2xl text-foreground-900 mb-8">
          {t("social.title")}
        </h3>

        <div className="grid grid-cols-3 gap-4 md:gap-8">
          <div className="flex flex-col items-center">
            <span className="font-heading text-3xl md:text-4xl text-accent-500 mb-2">
              {t("social.stat1.value")}
            </span>
            <span className="text-xs md:text-sm text-foreground-600">
              {t("social.stat1.label")}
            </span>
          </div>
          <div className="flex flex-col items-center">
            <span className="font-heading text-3xl md:text-4xl text-accent-500 mb-2">
              {t("social.stat2.value")}
            </span>
            <span className="text-xs md:text-sm text-foreground-600">
              {t("social.stat2.label")}
            </span>
          </div>
          <div className="flex flex-col items-center">
            <span className="font-heading text-3xl md:text-4xl text-accent-500 mb-2">
              {t("social.stat3.value")}
            </span>
            <span className="text-xs md:text-sm text-foreground-600">
              {t("social.stat3.label")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}